import { render } from "./CourtDiary.vue?vue&type=template&id=68aa44e4"
import script from "./CourtDiary.vue?vue&type=script&lang=js"
export * from "./CourtDiary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__